'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILE = exports.FILE = '__NATIVE_FILE__';
var URL = exports.URL = '__NATIVE_URL__';
var TEXT = exports.TEXT = '__NATIVE_TEXT__';


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dnd-html5-backend/lib/NativeTypes.js
 ** module id = 821
 ** module chunks = 0
 **/